<template>
    <div>
        <v-toolbar>
            <v-toolbar-items class="hidden-xs-only">
                <v-btn v-if="this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'" flat to="/customers">Заказчики</v-btn>
                <v-btn flat to="/users">Сотрудники </v-btn>

                <v-btn flat to="/requests">
                    <v-badge class="request-count">
                        <span v-if="this.notCount != null" slot="badge">{{this.notCount}}</span>
                    Заявки
                    </v-badge>
                </v-btn>
                <v-btn v-if="this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'" flat to="/requestsStatus">Журнал </v-btn>
            </v-toolbar-items>

            <div class="hidden-sm-and-up">
                <v-menu
                        :close-on-content-click="false"
                        :nudge-width="200"
                        offset-x
                >
                    <v-toolbar-side-icon slot="activator">
                        <v-icon style="font-size: 20px;">fa-bars</v-icon>
                    </v-toolbar-side-icon>
                    <v-list>
                        <v-list-tile v-if="this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'" class="link-class" to="/customers">
                            <v-list-tile-title>Заказчики</v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile class="link-class" to="/users">
                            <v-list-tile-title>Сотрудники</v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile class="link-class" to="/requests">
                            <v-list-tile-title>
                                Заявки ( <span v-if="this.notCount != null" color="primary">{{this.notCount}}</span> )

                            </v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile v-if="this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'" class="link-class" to="/requestsStatus">
                            <v-list-tile-title>Журнал</v-list-tile-title>
                        </v-list-tile>

                    </v-list>
                </v-menu>
            </div>
        </v-toolbar>
    </div>
</template>

<script>
    import axios from 'axios'
    import { UpdateNote } from '../main.js';
    import localForage from 'localforage'
    export default {
        data: () => ({
            backUrl: null,
            drawer: null,
            token: '',
            role: '',
            notCount: null,
            noteClear: null,
        }),
        created () {
            this.token = localStorage.getItem('token');
            this.role = localStorage.getItem('role');
            this.backUrl = localStorage.getItem('url');
            this.getNotifications()
            this.getNotificationsInterval()
            Event.$on('notes',() => {
                this.getNotifications()
            });
        },
        beforeDestroy () {
            clearInterval(this.noteClear)
            Event.$off('notes');
        },
        methods:{
            getNotifications(){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/bids/notifications',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    }
                }).then(response => {
                    if(response.data != '') {
                        this.notCount = response.data.metadata.actual_count
                    }else{
                        this.notCount = null
                    }

                })
            },

            getNotificationsInterval(){
                    this.noteClear = setInterval(() => {
                        axios({
                            method: 'get',
                            url: this.backUrl + '/api/bids/notifications',
                            withCredentials: true,
                            headers: {
                                'Authorization': 'Basic ' + this.token,
                            }
                        }).then(response => {
                            if (response.data != '') {
                                this.notCount = response.data.metadata.actual_count
                                UpdateNote.$emit('update-notes', response.data.data);
                            } else {
                                this.notCount = null
                            }
                        }).catch(error => {
                            if(error.response.data.error == 'Unauthorized'){
                                localStorage.clear();
                                this.$router.push('/login');
                                Event.$emit('logout');
                                localForage.clear()
                            }
                        })
                    }, 10000);
            },
        },


    }
</script>

<style>
.request-count .v-badge__badge{
    font-size: 12px;
    height: 26px;
    width: 26px;
    top: -13px;
    right: -26px;
}
</style>